module.exports = __webpack_public_path__ + "img/emtpy.8ba6a7ee.png";